/**
 * Spec FR7. The copy below is approved and exact. Do not reword it.
 *
 * No result, no score, no style name, no factor output. No back button, no
 * retake button, and no other call to action. Results are presented at the
 * session, not in this app.
 *
 * The only interactive element on this screen is the mailto link.
 */

const CARE_EMAIL = 'DNACare@dnabehavior.com';

interface Props {
  /**
   * Populated from memory during a normal run, or from localStorage after a
   * resume. Both are written at the same moment, so an empty value here means
   * storage was cleared by hand mid-assessment.
   */
  firstName: string;
}

export function Complete({ firstName }: Props) {
  return (
    <div className="card complete">
      <h1>
        Thanks{firstName ? `, ${firstName}` : ''}. Your responses have been recorded.
      </h1>
      <p>Your results will be presented to you at the session.</p>
      <p>
        If you would like your own personal reports, email{' '}
        <a href={`mailto:${CARE_EMAIL}`}>{CARE_EMAIL}</a> and we will send them to you.
      </p>
    </div>
  );
}
